import React, { createContext, useContext, useState, ReactNode } from 'react';
import type { Language } from '../content/site';
type LanguageContextValue = {
  language: Language;
  setLanguage: (lang: Language) => void;
};
const LanguageContext = createContext<LanguageContextValue | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('en');
  return <LanguageContext.Provider value={{
    language,
    setLanguage
  }} data-id="element-198" data-mp="3bt324fx1nhhw">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return ctx;
}